'use strict';

angular.module('AcaApp').factory('SessionInjectorService',
[
  '$window',
  '$location',
  '$q',
  '$interval',
  '$rootScope',
  'LockedScreenService',
  function($window, $location, $q, $interval, $rootScope, LockedScreenService){
    var apiRegEx = new RegExp(/^\/(upload|api)\/[a-zA-Z0-9]+$/);
    var clearSession = function(){
      $interval.cancel($rootScope.countDown);
      delete $window.sessionStorage.eulaHash;
      delete $window.sessionStorage.eulaText;
      delete $window.sessionStorage.token;
      delete $window.sessionStorage.userName;
      delete $window.sessionStorage.realName;
      delete $window.sessionStorage.secondsLeft;
      delete $window.sessionStorage.profile;
      delete $window.sessionStorage.MFAToken;
      delete $window.sessionStorage.MFAEnabled;
      delete $window.sessionStorage.fromAddPhone;
    };
    return {
      'request': function(config){
        if(apiRegEx.test(config.url)){
          config.headers.Authorization = $window.sessionStorage.token;
        }
        return config;
      },
      'requestError': function(config){
        return config;
      },
      'clearSession': function(){
        $interval.cancel($rootScope.countDown);
        delete $window.sessionStorage.eulaHash;
        delete $window.sessionStorage.eulaText;
        delete $window.sessionStorage.token;
        delete $window.sessionStorage.userName;
        delete $window.sessionStorage.realName;
        delete $window.sessionStorage.secondsLeft;
        delete $window.sessionStorage.profile;
        delete $window.sessionStorage.MFAToken;
        delete $window.sessionStorage.MFAEnabled;
        delete $window.sessionStorage.fromAddPhone;
      },
      'responseError': function(response){
        if(response.data.error){
          return $q.reject(response);
        }
        if(response.status === 555 || response.status === 500){
          if(response.data.indexOf('Code:1001') >= 0 || response.data.indexOf('Code:1002') >= 0){
            clearSession();
            $location.path('/login');
          }
          else if(response.data.indexOf('Code:1003') >= 0){
            clearSession();
            $location.path('/invalid-session');
          }
        }
        return $q.reject(response);
      },
      'response': function(response){
        if(response.status === 200){
          if(apiRegEx.test(response.config.url)){
            $window.sessionStorage.token = response.headers().authorization;
            $window.sessionStorage.secondsLeft = $window.sessionStorage.sessionExpireSetting;
          }
        }
        return response;
      }
    };
  }
]);